import React, { createContext, useState, useContext } from 'react';

interface HeaderContentContextType {
  headerContent: React.ReactNode;
  setHeaderContent: (content: React.ReactNode) => void;
}

const HeaderContentContext = createContext<HeaderContentContextType | undefined>(undefined);

export const HeaderContentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [headerContent, setHeaderContent] = useState<React.ReactNode>(null);

  return (
    <HeaderContentContext.Provider value={{ headerContent, setHeaderContent }}>
      {children}
    </HeaderContentContext.Provider>
  );
};

export const useHeaderContent = () => {
  const context = useContext(HeaderContentContext);
  if (!context) {
    throw new Error('useHeaderContent must be used within a HeaderContentProvider');
  }
  return context;
};